import { sortDestinationIdFormat } from "@redotech/redo-ids-cockroach";
import { SortDestinationColorSchema } from "@redotech/redo-model/wms/schema/sort-destination";
import { SortDispositionSchema } from "@redotech/redo-model/wms/schema/sort-disposition";
import * as z from "zod";

export const updateSortDestination = {
  name: "updateSortDestination" as const,
  input: z.object({
    id: sortDestinationIdFormat.schema,
    name: z.string().optional(),
    disposition: SortDispositionSchema.optional(),
    color: SortDestinationColorSchema.optional(),
  }),
  output: z.null(),
};
